import { makeStyles } from "@material-ui/core";

const sessionSummaryWins = makeStyles({
    win: {
        background: "linear-gradient(130deg, #29b6f6 0%, #29b6f6 11%, #29b6f6 40%, #53c4f7 100%)"
    },
    noWin: {
        background: "linear-gradient(145deg, #c62828 0%, #8a1c1c 81%, #c62828 100%, #8a1c1c 100%)"
    }
})

export default sessionSummaryWins